import React, { useEffect, useState } from "react";
import useAxiosInstance from "../../hooks/useAxios";
import { toast } from "react-toastify";
import { Accordion } from "flowbite-react";
import { FaSpinner } from "react-icons/fa";

const FileDetailsPage = () => {
  const axios = useAxiosInstance();
  const [data, setData] = useState({
    status: "success",
    data: {
      title: "Wokelo AI",
      text: [
        {
          heading: [
            "Compressing diligence cycle time, enhancing productivity by 10x research platform Typical project /",
            "Not used for model training research platform Internal data protection",
            "Competitive analysis research platform Wokelo is a Gen-AI powered secure strategic research platform",
            "research platform Contact Us",
            "Highest standards of security and data privacy research platform",
            "Co-founder & CEO research platform Our Team",
            "research platform Yohei Nakajima Our Team",
            "Jackie Churchwell Case Study: PE due diligence and value creation plan by Gratia research platform",
            "Tyler Dean research platform Our Team",
            "One-stop for all research needs research platform Wokelo helps you do more with less",
            "research platform Our Team",
            "research platform Wokelo's proprietary database",
            "research platform Case Study: Data room analysis and investment memos at Sage",
            "Grow business with existing FTEs research platform Wokelo helps you do more with less",
            "research platform Report generation",
            "research platform Private workspace",
            "Customer's internal data not stored research platform Internal data protection",
            "Query anonymization research platform",
            "Compressing diligence cycle time, enhancing productivity by 10x research platform Traditional research",
            "human hours research platform Wokelo helps you do more with less",
            "Gen-AI powered investment",
            "Custom analysis research platform Wokelo is a Gen-AI powered secure strategic research platform",
            "Compressing diligence cycle time, enhancing productivity by 10x research platform Wokelo AI powered workflow",
            "CEO Tata Strategic research platform Our Team",
            "research platform Founder, Confluence VC Our Team",
            "discover insights first research platform Wokelo helps you do more with less",
            "Reduce cycle time research platform Wokelo helps you do more with less",
            "Compressing diligence cycle time, enhancing productivity by 10x research platform",
            "Ken Horenstein research platform Our Team",
            "Connect diverse sources of choice research platform",
            "research platform Bespoke analysis on any topic: Wokelo is a Gen-AI powered secure strategic research platform",
            "Create instant custom analysis research platform",
            "6-8 weeks Compressing diligence cycle time, enhancing productivity by 10x research platform",
            "research platform Internal data protection Enterprise grade cloud security",
            "Compressing diligence cycle time, enhancing productivity by 10x research platform < 1 week",
            "Compressing diligence cycle time, enhancing productivity by 10x 6-12 days research platform",
            "research platform Industry analysis Wokelo is a Gen-AI powered secure strategic research platform",
            "Shruti Van Dyke research platform Our Team",
            "research platform Internal data protection",
            "Compressing diligence cycle time, enhancing productivity by 10x research platform 4-10 days",
            "Founder, Array Ventures research platform Our Team",
            "research platform Premium datasets",
            "research platform",
            "Case Study: PE due diligence and value creation plan by Gratia research platform",
            "research platform Wokelo helps you do more with less Shorter time to insight",
            "Compressing diligence cycle time, enhancing productivity by 10x research platform 5-10 days",
            "Compressing diligence cycle time, enhancing productivity by 10x research platform transaction",
            "Internal datasets research platform",
            "Analysis research platform",
            "research platform Curated datasets",
            "Data privacy & confidentiality research platform Internal data protection",
            "Steven Imes IV research platform Case Study: Data room analysis and investment memos at Sage",
            "Partner, Breakwater ventures research platform Our Team",
            "4-8 days Compressing diligence cycle time, enhancing productivity by 10x research platform",
            "Partner, Pack ventures research platform Our Team",
            "Peter Mueller research platform Our Team",
            "research platform Wokelo helps you do more with less Gain competitive edge",
            "AI Cognitive Engine research platform",
            "research platform Internal data protection SOC II compliant platform",
            "research platform Save premium Wokelo helps you do more with less",
            "Industry/sector analysis across: research platform Wokelo is a Gen-AI powered secure strategic research platform",
            "research platform Wokelo is a Gen-AI powered secure strategic research platform",
            "research platform Wokelo helps you do more with less",
            "Company due diligence research platform Wokelo is a Gen-AI powered secure strategic research platform",
            "research platform Get ahead of the curve, Wokelo helps you do more with less",
            "Mangesh Sathe research platform Our Team",
            "Comprehensive business research capabilities research platform",
            "research platform Rationalize spend on outsourcing Wokelo helps you do more with less",
            "Founder, Untapped VC research platform Our Team",
            "Co-founder & CTO research platform Our Team",
            "Compressing diligence cycle time, enhancing productivity by 10x With Wokelo research platform",
            "outsourced research research platform Wokelo helps you do more with less",
            "Compare multiple co.'s across: research platform Wokelo is a Gen-AI powered secure strategic research platform",
          ],
          num_words: 491,
          content:
            "Overview Competitive intelligence Sector research Financial analysis Due diligence Primary insights Custom analysis ......   50+ connectors, custom integrations Reports marketplace >10k sector reports Company database 3M+ companies 300+ curated tier-1 publishers 20+ premium data providers Ready to use outputs in Word, PPT, and more Configurable data elements and templates Customizable to align with your firm's process   Diligence on Private & Public co.'s: Product insights Financial analysis Data room synthesis Voice of customer M&A strategy Hiring strategy   Product portfolio Value proposition Financials & funding Market maps Growth metrics Business model  Market size Value chain Top players Market segments Innovation & start-ups Trends and news  Context based search Facts and figures Q&A on focus topics Knowledge repository Reading list Brainstorming And many more capabilities to come (e.g., Primary insights, Benchmarks, Pricing, Internal data analysis)  Financial analysis Insights Synthesis Industry & market research Recommendatio ns Deliverable creation Triangulation Insights Synthesis Industry & market research Recommendations Deliverable creation Triangulation Company analysis     Notes: Based on user research (30+ interviews with professionals across corporate strategy, PE/VC, management consulting, Investment banks)  Project completion   (Duration) (Duration)    End-to-end encryption      I recently had a consulting project related to climate tech, which required an in-depth analysis of market size, market economics, competitor offerings, and trends. There was minimal data available in this private sector, and Wokelo.AI was able to provide insights in minutes that would have normally taken weeks to manually compile in an executive-ready presentation. AI tools like Wokelo can significantly improve productivity to support human consultants in an impactful way. Founder, Gratia Consulting As an analyst combing through dozens of documents daily, the Data Room Synthesis helps me extract insights from huge data rooms and draft investment memos. When it comes to investment due diligence, Wokelo has been a game-changer for me. I've used many generative AI tools over the past year, but Wokelo's industry & company research tools have provided the most accurate and comprehensive reports. Wokelo helps me get smart fast, so I can focus my research in the right places. PE/VC Analyst, Sage Collective Reduce spend on  Perform weeks of analysis in days, free- up time for problem solving & decisions Make workforce 10x productive, more throughput (projects) to grow business Save hundreds of thousands annually on external market research services Single platform for all needs, optimize spend on subscriptions and reports Mine insights across hundreds of documents in seconds Faster data-driven decisioning, get intelligence before competitors     Sid Masson , NLP M.Sc 10+ years in Corp Dev. & M&A Ex Monitor Deloitte, Tata Group, Federal Govt. Saswat Nanda , B.Eng., MBA 10+ years in strategy, AI for Insure-tech Ex. Monitor Deloitte, Tata AIG. Larsen & Toubro  Creator BabyAGI, Ex Techstars Dr. Arvind N., PHD Lead Researcher - Open AI Leading LLM Scientist (GPT)  Ex Microsoft M12  Ex BCG, PwC Investors and advisors  Ex IBM, Samsung  Ex Point 72, Morgan Stanley  Ex Carta, Bank of America Wokelo Inc.    2023 Email: support@wokelo.ai | Wokelo Inc., Seattle, WA www.wokelo.ai",
        },
      ],
    },
  });
  const [isLoading, setIsLoading] = useState(false);
  const fileName = window.location.href.split("/").pop();
  useEffect(() => {
    setIsLoading(true);
    axios
      .get(`/assets/file_data/?file_name=${fileName}`)
      .then((res) => {
        setData(res.data);
        setIsLoading(false);
        console.log(res.data);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
        toast.error("Something went Wrong");
      });
  }, []);
  const TesxtWithBreakLine=({textWithNewlines})=> textWithNewlines.split('\n').map((line, index) => {
    return <React.Fragment key={index}>{line}<br /></React.Fragment>;
  });

  return isLoading ? (
    <div className="h-screen animate-spin flex justify-center items-center">
      <FaSpinner className="text-xl" />
    </div>
  ) : (
    <div className="mt-10 mr-2">
      <div className="py-3 px-2 mb-5 bg-white rounded-xl shadow-md">
        <div className="text-3xl font-semibold ">{data.data.title}</div>
        <div className="flex justify-end">
          <div className="px-2 py-1 border text-sm rounded-xl">
            {data.status}
          </div>
        </div>
      </div>

      {data.data.text.map((elem) => {
        return (
          <div className="relative bg-white py-3 px-2 mb-3 rounded-xl shadow-md">
            <div className="right-12 top-5 absolute">
              <div className="px-2 py-1 border text-sm rounded-xl">
                Number of words : {elem.num_words} (via api and via content : {elem.content.split(' ').length})
              </div>
            </div>
            <Accordion className="border-0">
              {/* <Accordion.Panel>
                <Accordion.Title className="border-0 px-3 py-2">
                  <div className="text-xl font-medium">
                    Headings{" "}
                    <span className="text-sm">({elem.heading[0]})</span>
                  </div>
                </Accordion.Title>
                <Accordion.Content className="px-3 py-2">
                  {elem.heading.map((element) => {
                    return <li className="mb-2">{element}</li>;
                  })}
                </Accordion.Content>
              </Accordion.Panel> */}
              <Accordion.Panel>
                <Accordion.Title className="border-0 px-3 py-2">
                  <div className="text-xl font-medium">Content </div>
                </Accordion.Title>
                <Accordion.Content className="px-3 py-2 text-sm">
                  
                  <TesxtWithBreakLine textWithNewlines={elem.content}/>
                  {/* {elem.content} */}
                </Accordion.Content>
              </Accordion.Panel>
            </Accordion>
          </div>
        );
      })}
    </div>
  );
};

export default FileDetailsPage;
